// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__2QIGW","title":"ClientReferral_title__1mgQK","itemText":"ClientReferral_itemText__sJ3RR"};